import { createContext, useContext } from "react";

export const StaffingPeopleContext = createContext(null);

export const useStaffingPeopleContext = () => useContext(StaffingPeopleContext);
